export default __webpack_public_path__ + "static/media/american-express.9daa2312.svg";